module.exports = __webpack_public_path__ + "img/login-background2.598b2abd.jpg";